/* eslint-disable */
import asBasis from "@/services/as.basis.service";
import mathFormulaService from "@/services/math.formula.service";
import acpBasis from "@/services/acp.basis.service";
import { winkelToTableIndex } from "@/services/actuator.drehmoment-map.service";

let khWinkelArray: number[] = [];
for (let i = 95; i >= -5; i--) {
    khWinkelArray.push(i);
}

/**
 * used in checkChartSRO and checkChartSRC
 *  5 = 90°...
 *  all indexes which will not checked
 *  checked indexes => 90°, 80° - 10°, 0°
 */
const invertetDefaultAngleValues = [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 86, 87, 88, 89, 90, 91, 92, 93, 94, 96, 97, 98, 99, 100];
let defaultAngleValues: number[] = [];
for (let i = 0; i < 100; i++) {
    let exist = false;
    for (let j = 0; j < invertetDefaultAngleValues.length; j++) {
        if (i === invertetDefaultAngleValues[j]) {
            exist = true;
            break;
        }
    }
    if (!exist) {
        defaultAngleValues.push(i);
    }
}

/**
 *
 */
const invertedAngleValues = [0, 1, 2, 3, 4, 96, 97, 98, 99, 100];
let angleValues: number[] = [];
for (let i = 0; i < 100; i++) {
    let exist = false;
    for (let j = 0; j < invertedAngleValues.length; j++) {
        if (i === invertedAngleValues[j]) {
            exist = true;
            break;
        }
    }
    if (!exist) {
        angleValues.push(i);
    }
}


let securityFactorsTorques = {
    bto: 0,
    btoRunning: 0,
    eto: 0,
    btc: 0,
    btcRunning: 0,
    etc: 0
}

let torques = {
    bto: 0,
    btoRunning: 0,
    eto: 0,
    btc: 0,
    btcRunning: 0,
    etc: 0
}

let winkelKraftObject = {
    bto: {
        bisWinkel: 0,
        kraft: 0, // bto * sicherheitsfaktor
        torque: 0,
        securityFactor: 0,
    },
    btoRunning: {
        bisWinkel: 0,
        kraft: 0, // running * sicherheitsfaktor
        torque: 0,
        securityFactor: 0,
    },
    eto: {
        bisWinkel: 0,
        kraft: 0, // eto * sicherheitsfaktor
        torque: 0,
        securityFactor: 0,
    },
    btc: {
        bisWinkel: 0,
        kraft: 0, //  btc * sicherheitsfaktor
        torque: 0,
        securityFactor: 0,
    },
    btcRunning: {
        bisWinkel: 0,
        kraft: 0, // runningOut * sicherheitsfaktor
        torque: 0,
        securityFactor: 0,
    },
    etc: {
        bisWinkel: 0,
        kraft: 0, // etc * sicherheitsfaktor
        torque: 0,
        securityFactor: 0,
    }
};


const setWinkelkraft = (torques: any, securityFactors: any, angles: any) => {
    winkelKraftObject.bto.kraft = torques.bto * securityFactors.bto;
    winkelKraftObject.btoRunning.kraft = torques.btoRunning * securityFactors.btoRunning;
    winkelKraftObject.eto.kraft = torques.eto * securityFactors.eto;
    winkelKraftObject.btc.kraft = torques.btc * securityFactors.btc;
    winkelKraftObject.btcRunning.kraft = torques.btcRunning * securityFactors.btcRunning;
    winkelKraftObject.etc.kraft = torques.etc * securityFactors.etc;

    winkelKraftObject.bto.torque = torques.bto;
    winkelKraftObject.btoRunning.torque = torques.btoRunning;
    winkelKraftObject.eto.torque = torques.eto;
    winkelKraftObject.btc.torque = torques.btc;
    winkelKraftObject.btcRunning.torque = torques.btcRunning;
    winkelKraftObject.etc.torque = torques.etc;

    winkelKraftObject.bto.securityFactor = securityFactors.bto;
    winkelKraftObject.btoRunning.securityFactor = securityFactors.btoRunning;
    winkelKraftObject.eto.securityFactor = securityFactors.eto;
    winkelKraftObject.btc.securityFactor = securityFactors.btc;
    winkelKraftObject.btcRunning.securityFactor = securityFactors.btcRunning;
    winkelKraftObject.etc.securityFactor = securityFactors.etc;

    if (angles.bto === 0 && angles.btoRunning === 0 && angles.eto === 0 && angles.btc === 0 && angles.btcRunning === 0 && angles.etc === 0) {

        winkelKraftObject.bto.bisWinkel = 0;
        winkelKraftObject.btoRunning.bisWinkel = 90;
        winkelKraftObject.eto.bisWinkel = 90;
        winkelKraftObject.btc.bisWinkel = 90;
        winkelKraftObject.btcRunning.bisWinkel = 90;
        winkelKraftObject.etc.bisWinkel = 0;
    } else {
        winkelKraftObject.bto.bisWinkel = angles.bto;
        winkelKraftObject.btoRunning.bisWinkel = angles.btoRunning;
        winkelKraftObject.eto.bisWinkel = angles.eto;
        winkelKraftObject.btc.bisWinkel = angles.btc;
        winkelKraftObject.btcRunning.bisWinkel = angles.btcRunning;
        winkelKraftObject.etc.bisWinkel = angles.etc;
    }
    return winkelKraftObject;
}

const getWinkelkraftObject = () => {
    return winkelKraftObject;
}

const isCustomDrehwinkel = () => {
    const winkelKraftObject = getWinkelkraftObject();

    if (winkelKraftObject.bto.bisWinkel === 0 && winkelKraftObject.btoRunning.bisWinkel === 90 && winkelKraftObject.eto.bisWinkel === 90 && winkelKraftObject.btc.bisWinkel === 90 && winkelKraftObject.btcRunning.bisWinkel === 0 && winkelKraftObject.etc.bisWinkel === 0) {
        return false;
    }

    return true
}


const setTorques = (bto: number, btoRunning: number, eto: number, btc: number, btcRunning: number, etc: number) => {
    torques.bto = bto;
    torques.btoRunning = btoRunning;
    torques.eto = eto;
    torques.btc = btc;
    torques.btcRunning = btcRunning;
    torques.etc = etc;
    return torques;
}

/* ERSTELLEN DER SICHERHEITSFAKTOREN */
const setSecurityFactors = (btoSecFac: number, runningSecFac: number, etoSecFac: number, btcSecFac: number, runningOutSecFac: number, etcSecFac: number) => {
    securityFactorsTorques.bto = btoSecFac;
    securityFactorsTorques.btoRunning = runningSecFac;
    securityFactorsTorques.eto = etoSecFac;
    securityFactorsTorques.btc = btcSecFac;
    securityFactorsTorques.btcRunning = runningOutSecFac;
    securityFactorsTorques.etc = etcSecFac;
}

const getSecurityFactors = (): any => {
    return securityFactorsTorques;
}

/* BERECHNUNG GAS/PNEUMATIK ZYLINDER */
const getKolbeFlaecheEinzeln = (zylinderdurchmesser: number) => { // =((QUADRATESUMME(C8)*PI())/4)
    const array: number[] = [];
    array.push(zylinderdurchmesser);
    let sum = 0;
    let i = array.length;
    while (i--) {
        sum += Math.pow(array[i], 2);
    }
    sum = (sum * Math.PI) / 4;
    return sum;
};

const getZylinderraum = (zylDurchmesser: number, items: number, antrieb: number, kolbenstange_durchmesser: number[]) => {

    // SHEET Berechnung
    let kolbeDurchmesser = zylDurchmesser;
    let kolbeFlaecheEinzeln = 0;
    let kolbenAnzahl = 1;
    let kolbeGesamflaeche = 0;
    let einfacherKolbenDurchmesser = 0;

    let kolbenstangeFlaecheEinzeln = 0;
    let kolbenstangeDurchmesser = 0;

    let kreisringflaecheEinzeln = 0;
    let kreisringflaecheGesamt = 0;

    kolbeFlaecheEinzeln = getKolbeFlaecheEinzeln(zylDurchmesser);

    kolbenstangeFlaecheEinzeln = (Math.PI * (kolbenstange_durchmesser[antrieb] * kolbenstange_durchmesser[antrieb]) / 4);

    if (items === 2) {
        kolbeGesamflaeche = kolbeFlaecheEinzeln + (kolbeFlaecheEinzeln - kolbenstangeFlaecheEinzeln);
    } else if (items === 3) {
        kolbeGesamflaeche = kolbeFlaecheEinzeln + (2 * (kolbeFlaecheEinzeln - kolbenstangeFlaecheEinzeln));
    } else {
        kolbeGesamflaeche = kolbeFlaecheEinzeln;
    }

    kreisringflaecheEinzeln = kolbeFlaecheEinzeln - kolbenstangeFlaecheEinzeln;

    kreisringflaecheGesamt = kreisringflaecheEinzeln * items;
    einfacherKolbenDurchmesser = Math.pow((4 * kreisringflaecheEinzeln / Math.PI), 0.5);

    return {
        kolbeGesamflaeche: kolbeGesamflaeche,
        kreisringflaecheEinzeln: kreisringflaecheEinzeln,
        kreisringflaecheGesamt: kreisringflaecheGesamt,
        einfacherKolbenDurchmesser: einfacherKolbenDurchmesser,
        kreisring: einfacherKolbenDurchmesser,
        kreisflaeche: zylDurchmesser,
        kolbeFlaecheEinzeln: kolbeFlaecheEinzeln,
        kolbenstangeFlaecheEinzeln: kolbenstangeFlaecheEinzeln
    };
}

const flaecheZylinderrohrraum = (controlType: string, zylDurchmesser: number, items: number, antrieb: number, kolbenstange_durchmesser: number[]) => {
    let zylinderrohrraum: any;
    if (controlType !== 'HYD') {
        zylinderrohrraum = getZylinderraum(zylDurchmesser, items, antrieb, kolbenstange_durchmesser);
    } else {
        zylinderrohrraum = {};
    }
    return zylinderrohrraum;
};

let klappe: any = {
    open: [],
    close: []
}

const setKlappe = () => {

    let klappeBTO_ETOarray = [];
    let klappeBTC_ETCarray = [];

    // console.log('isCustomDrehwinkel', isCustomDrehwinkel());
    // console.log('winkelKraftObject', winkelKraftObject);




    /* Standartwerte
    winkelKraftObject.bto.bisWinkel = 0;
    winkelKraftObject.btoRunning.bisWinkel = 90;
    winkelKraftObject.eto.bisWinkel = 90;

    winkelKraftObject.btc.bisWinkel = 90;
    winkelKraftObject.btcRunning.bisWinkel = 90;
    winkelKraftObject.etc.bisWinkel = 0;
    */

    /* Customwerte
    winkelKraftObject.bto.bisWinkel = 2;
    winkelKraftObject.btoRunning.bisWinkel = 88;
    winkelKraftObject.eto.bisWinkel = 90;

    winkelKraftObject.btc.bisWinkel = 88;
    winkelKraftObject.btcRunning.bisWinkel = 2;
    winkelKraftObject.etc.bisWinkel = 0.1;
    */




    if (isCustomDrehwinkel()) {

        console.log('winkelKraftObject', winkelKraftObject)

        let i = -5
        do {
            if (i <= winkelKraftObject.bto.bisWinkel) {
                klappeBTO_ETOarray.push(+winkelKraftObject.bto.kraft.toFixed(0));
            } else if (i < winkelKraftObject.btoRunning.bisWinkel) {
                klappeBTO_ETOarray.push(+winkelKraftObject.btoRunning.kraft.toFixed(0));
            } else {
                klappeBTO_ETOarray.push(+winkelKraftObject.eto.kraft.toFixed(0));
            }
            i++;
        }
        while (i < khWinkelArray.length - 5);


        // Hier logik umstruktierung
        let j = -5;
        do {
            if (j <= winkelKraftObject.btcRunning.bisWinkel) {
                klappeBTC_ETCarray.push(+winkelKraftObject.etc.kraft.toFixed(0));
            } else if (j < winkelKraftObject.btc.bisWinkel) {
                klappeBTC_ETCarray.push(+winkelKraftObject.btcRunning.kraft.toFixed(0));
            } else {
                klappeBTC_ETCarray.push(+winkelKraftObject.btc.kraft.toFixed(0));
            }
            j++;
        }
        while (j < khWinkelArray.length - 5);

    } else {

        /* Standartwerte
    winkelKraftObject.bto.bisWinkel = 0;
    winkelKraftObject.btoRunning.bisWinkel = 90;
    winkelKraftObject.eto.bisWinkel = 90;

    winkelKraftObject.btc.bisWinkel = 90;
    winkelKraftObject.btcRunning.bisWinkel = 90; oder 0
    winkelKraftObject.etc.bisWinkel = 0;
    */

        // console.log('bto', winkelKraftObject.bto.bisWinkel)
        // console.log('btoRunning', winkelKraftObject.btoRunning.bisWinkel)
        // console.log('eto', winkelKraftObject.eto.bisWinkel)
        // console.log('etc', winkelKraftObject.etc.bisWinkel)
        // console.log('btcRunning', winkelKraftObject.btcRunning.bisWinkel)
        // console.log('btc', winkelKraftObject.btc.bisWinkel)


        let i = -5
        do {
            if (i <= winkelKraftObject.bto.bisWinkel) {
                klappeBTO_ETOarray.push(+winkelKraftObject.bto.kraft.toFixed(0));
            } else if (i < winkelKraftObject.btoRunning.bisWinkel) {
                klappeBTO_ETOarray.push(+winkelKraftObject.btoRunning.kraft.toFixed(0));
            } else {
                klappeBTO_ETOarray.push(+winkelKraftObject.eto.kraft.toFixed(0));
            }
            i++;
        }
        while (i < khWinkelArray.length - 5);

        let j = -5;
        do {
            if (j <= winkelKraftObject.etc.bisWinkel) {
                klappeBTC_ETCarray.push(+winkelKraftObject.etc.kraft.toFixed(0));
            } else if (j < winkelKraftObject.btc.bisWinkel) {
                klappeBTC_ETCarray.push(+winkelKraftObject.btcRunning.kraft.toFixed(0));
            } else {
                klappeBTC_ETCarray.push(+winkelKraftObject.btc.kraft.toFixed(0));
            }
            j++;
        }
        while (j < khWinkelArray.length - 5);
    }






    klappe.open = klappeBTO_ETOarray.reverse();
    klappe.close = klappeBTC_ETCarray.reverse();

    // console.log('klappe.open', klappe.open)
    // console.log('klappe.close', klappe.close)
    // console.log('--------------------------------');
}

const getKlappe = () => {
    return klappe;
}

const getZylinderkraft = (driveType: string, pressure: number, kolbenKreisringFlaeche: number) => {
    return Math.round((pressure / 10) * kolbenKreisringFlaeche);
}

const setMaxNettoAntrieb = (antriebsIndex: number, tolerance: number, driveTypeA: string) => {
    let base: any;

    switch (driveTypeA) {
        case 'AS-S':
            base = asBasis;
            break;
        case 'AS-C':
            base = asBasis;
            break;
        case 'AS':
            base = asBasis;
            break;
        case 'ACP':
            base = acpBasis;
            break;
        case 'ACSP':
            // base = acspBasis;
            break;
    }

    let maxNetActuatorTorque = 0;
    if (driveTypeA === 'AS-S' || driveTypeA === 'AS-C' || driveTypeA === 'AS') {
        // TODO: AS bugfixen
        if (driveTypeA === 'AS-S') {
            maxNetActuatorTorque = base.ANTRIEBE_MAX_NETTO_DREHMOMENT_ASS[antriebsIndex] + (base.ANTRIEBE_MAX_NETTO_DREHMOMENT_ASS[antriebsIndex] * tolerance / 100);
        } else {
            maxNetActuatorTorque = base.ANTRIEBE_MAX_NETTO_DREHMOMENT_ASC[antriebsIndex] + (base.ANTRIEBE_MAX_NETTO_DREHMOMENT_ASC[antriebsIndex] * tolerance / 100);
        }
    } else {
        maxNetActuatorTorque = base.ANTRIEBE_MAX_NETTO_DREHMOMENT[antriebsIndex] + (base.ANTRIEBE_MAX_NETTO_DREHMOMENT[antriebsIndex] * tolerance / 100);
    }

    return maxNetActuatorTorque;
}

const getTable = (antrieb: number, knickwinkel: number, zylinderkraft: number, driveTypeA: string, zylIndex?: number) => {
    let base: any;

    switch (driveTypeA) {
        case 'AS-S':
            base = asBasis;
            break;
        case 'AS-C':
            base = asBasis;
            break;
        case 'AS':
            base = asBasis;
            break;
        case 'ACP':
            base = acpBasis;
            break;
        case 'ACSP':
            // base = acspBasis;
            break;
    }
    const hebel = base.getHebelarm(antrieb);
    const wirkungsgradzylinder = base.getWirkungsgradZylinder();



    let winkelValue = 0;
    let winkelArray: number[] = [];

    let knicklaengeValue = 0;
    let knicklaengeArray: number[] = [];
    let hebellaengeValue = 0;
    let hebellaengeArray: number[] = [];
    let knickwinkelGradValue = 0;
    let knickwinkelGradArray: number[] = [];
    let hebelwinkelGradValue = 0;
    let hebelwinkelGradArray: number[] = [];
    let zylinderKraftValue = 0;
    let zylinderKraftArray: number[] = [];
    let fResValue = 0;
    let fResArray: number[] = [];
    let mZylValue = 0;
    let mZylArray: number[] = [];
    let fQuerValue = 0;
    let fQuerArray: number[] = [];
    let hubTotalArray: number[] = [];
    let hubTotalValue = 0;

    let hebellaengeValueHubTotalHELPER = 0;
    let knickwinkelGradValueHubTotalHELPER = 0;
    let hebelwinkelGradValueHubTotalHELPER = 0;

    let hub90ArrayHelper: number[] = [];
    let hub90Value = 0;

    let hebellaengeValueHub90HELPER = 0;
    let knickwinkelGradValueHub90HELPER = 0;
    let hebelwinkelGradValueHub90HELPER = 0;


    // if (antrieb === 4 && zylIndex === 8) {
    //     console.log('hebel', hebel);
    //     console.log('wirkungsgradzylinder', wirkungsgradzylinder);
    // }

    for (let i = 0; i < khWinkelArray.length; i++) {


        // spalte 1
        /* knickwinkel abhängigkeit von CANTED oder SYM */
        winkelValue = 360 - (225 - knickwinkel + khWinkelArray[i]);
        winkelArray.push(winkelValue);



        // spalte 2
        knicklaengeValue = (hebel - (hebel * Math.sin(mathFormulaService.degreeToRadians(winkelValue - knickwinkel)))) / Math.cos(mathFormulaService.degreeToRadians(90 - winkelValue));
        knicklaengeArray.push(+knicklaengeValue.toFixed(3));

        // spalte 3
        hebellaengeValue = Math.sqrt((hebel * hebel) + (knicklaengeValue * knicklaengeValue) - (2 * hebel * knicklaengeValue * Math.cos(mathFormulaService.degreeToRadians(180 - knickwinkel))));
        hebellaengeArray.push(+hebellaengeValue.toFixed(3));

        // spalte 4
        knickwinkelGradValue = mathFormulaService.radiansToDegrees(Math.asin(hebel * (Math.sin(mathFormulaService.degreeToRadians(180 - knickwinkel)) / hebellaengeValue)));
        knickwinkelGradArray.push(+knickwinkelGradValue.toFixed(2));

        // spalte 5
        hebelwinkelGradValue = 90 - winkelValue;
        hebelwinkelGradArray.push(+hebelwinkelGradValue.toFixed(1));

        // spalte 6
        zylinderKraftValue = zylinderkraft;
        zylinderKraftArray.push(+zylinderKraftValue.toFixed(2));

        // spalte 7
        fResValue = ((zylinderKraftValue / (Math.cos(mathFormulaService.degreeToRadians(180 - hebelwinkelGradValue)))) * -1);
        fResArray.push(+fResValue.toFixed());

        // spalte 8 =(I18*E18/1000)*$C$10
        mZylValue = (fResValue * hebellaengeValue / 1000) * wirkungsgradzylinder;
        mZylArray.push(+mZylValue.toFixed(0));

        // spalte 9 =(WURZEL(QUADRATESUMME(I17)-QUADRATESUMME(H17)))
        fQuerValue = Math.sqrt((fResValue * fResValue) - (zylinderKraftValue * zylinderKraftValue));
        fQuerArray.push(+fQuerValue.toFixed(0));

        // TODO: 95° bis 90° fix
        if (i === 0) {
            hebellaengeValueHubTotalHELPER = hebellaengeValue;
            knickwinkelGradValueHubTotalHELPER = knickwinkelGradValue;
            hebelwinkelGradValueHubTotalHELPER = hebelwinkelGradValue;
        } else if (i === 5) {
            hebellaengeValueHub90HELPER = +hebellaengeValue.toFixed(3);
            knickwinkelGradValueHub90HELPER = +knickwinkelGradValue.toFixed(3);
            hebelwinkelGradValueHub90HELPER = +hebelwinkelGradValue.toFixed(3);
        }

        // spalte 10 =((SIN(BOGENMASS(($F$17+$G$17)))*$E$17)-(SIN(BOGENMASS((F17+G17)))*E17))
        hubTotalValue = (Math.sin(mathFormulaService.degreeToRadians(knickwinkelGradValueHubTotalHELPER + hebelwinkelGradValueHubTotalHELPER)) * hebellaengeValueHubTotalHELPER) - (Math.sin(mathFormulaService.degreeToRadians(knickwinkelGradValue + hebelwinkelGradValue)) * hebellaengeValue);
        hubTotalArray.push(+hubTotalValue.toFixed(2));

        if (i === 1) {
            hub90ArrayHelper[0] = 0 - (+hubTotalValue.toFixed(2));
        }

        // spalte 11 =SIN(BOGENMASS(($F$18+$G$18)))*$E$18)-(SIN(BOGENMASS((F17+G17)))*E17
        hub90Value = (Math.sin(mathFormulaService.degreeToRadians((knickwinkelGradValueHub90HELPER + hebelwinkelGradValueHub90HELPER))) * hebellaengeValueHub90HELPER) - (Math.sin(mathFormulaService.degreeToRadians(knickwinkelGradValue + hebelwinkelGradValue)) * hebellaengeValue);
        hub90ArrayHelper.push(+hub90Value.toFixed(2));
    }

    return {

        winkelArray: winkelArray,
        khWinkelArray: khWinkelArray,
        knicklaengeArray: knicklaengeArray,
        hebellaengeArray: hebellaengeArray,
        knickwinkelGradArray: knickwinkelGradArray,
        hebelwinkelGradArray: hebelwinkelGradArray,
        zylinderKraftArray: zylinderKraftArray,
        fResArray: fResArray,
        mZylArray: mZylArray,
        fQuerArray: fQuerArray,
        hubTotalArray: hubTotalArray,
        hub90ArrayHelper: hub90ArrayHelper
    }
}

const getFederTable = (antriebsIndex: number, federpaketIndex: number, driveTypeA: string, hubTotalArray: number[], hebelwinkelGradArray: number[], hebellaengeArray: number[], mZylArray: number[], knickwinkel: number, federKEY: string) => {
    let base: any;

    switch (driveTypeA) {
        case 'AS-S':
            base = asBasis;
            break;
        case 'AS-C':
            base = asBasis;
            break;
        case 'AS':
            base = asBasis;
            break;
        case 'ACP':
            base = acpBasis;
            break;
        case 'ACSP':
            // base = acspBasis;
            break;
    }

    let federkraftArray: number[] = [];
    let federkraftValue = 0;

    const lasthubTotalValue = hubTotalArray[khWinkelArray.length - 1];

    let fRESFederzylinderArray: number[] = [];
    let fRESFederzylinderValue = 0;

    let mFEDFederzylinderArray: number[] = [];
    let mFEDFederzylinderValue = 0;

    let fQuerFederzylinderArray: number[] = [];
    let fQuerFederzylinderValue = 0;

    let mResZylArray: number[] = [];
    let mResZylValue = 0;

    let klappeBTOETOArray: number[] = [];

    let klappeBTCETCArray: number[] = [];

    for (let j = 0; j < khWinkelArray.length; j++) {
        // spalte 13

        federkraftValue = ((base.FEDERRATEARRAY[antriebsIndex][federKEY][0] * (base.VORSPANNUNGARRAY[antriebsIndex][federKEY] + (lasthubTotalValue - hubTotalArray[j]))) * base.FEDERPAKETEANZAHLARRAY[antriebsIndex][federKEY]) +
            (base.FEDERRATEARRAY[antriebsIndex][federKEY][1] * (base.VORSPANNUNGARRAY[antriebsIndex][federKEY] + (lasthubTotalValue - hubTotalArray[j])) * base.FEDERPAKETEANZAHLARRAY[antriebsIndex][federKEY]);
        federkraftArray.push(+federkraftValue.toFixed(0));

        // =((N17/(COS(BOGENMASS(180-G17))))*-1)
        fRESFederzylinderValue = (federkraftValue / Math.cos(mathFormulaService.degreeToRadians(180 - hebelwinkelGradArray[j]))) * -1;
        fRESFederzylinderArray.push(+fRESFederzylinderValue.toFixed(0));

        // =(O17*E17/1000)*$E$10
        mFEDFederzylinderValue = (fRESFederzylinderValue * hebellaengeArray[j] / 1000) * base.WIRKUNGSGRADFEDER;
        mFEDFederzylinderArray.push(+mFEDFederzylinderValue.toFixed(0));

        // =(WURZEL(QUADRATESUMME(O18)-QUADRATESUMME(N18)))
        fQuerFederzylinderValue = Math.sqrt((fRESFederzylinderValue * fRESFederzylinderValue) - (federkraftValue * federkraftValue));
        fQuerFederzylinderArray.push(+fQuerFederzylinderValue.toFixed(0));

        // =J17-P17
        mResZylValue = mZylArray[j] - mFEDFederzylinderValue;
        mResZylArray.push(+mResZylValue.toFixed(0));

        // getklappe
    }
    klappeBTOETOArray = getKlappe().open;
    klappeBTCETCArray = getKlappe().close;

    if (knickwinkel === 0) {
        driveTypeA = 'AS-S';
    } else if (knickwinkel === 12) {
        driveTypeA = 'AS-C';
    }

    // SRO
    let federkraftSROarray: number[] = [];

    let fRESFederzylinderSROarray: number[] = [];
    let fRESFederzylinderSROValue = 0;
    let mFEDFederzylinderSROarray: number[] = [];
    let mFEDFederzylinderSROValue = 0;
    let fQuerFederzylinderSROarray: number[] = [];
    let fQuerFederzylinderSROValue = 0;
    let mResZylSROarray: number[] = [];
    let mResZylSROValue = 0;
    let klappeSRO_BTOETOarray: number[] = [];

    let klappeSRO_BTCETCarray: number[] = [];

    /* kopieren der Arrays für SRO, falls Symmetrisch */
    for (let cop = 0; cop < federkraftArray.length; cop++) {
        federkraftSROarray.push(federkraftArray[cop]);
    }
    federkraftSROarray = federkraftSROarray.reverse();

    if (driveTypeA === 'AS-S' || driveTypeA === 'ACP') {
        for (let cop = 0; cop < fRESFederzylinderArray.length; cop++) {
            fRESFederzylinderSROarray.push(fRESFederzylinderArray[cop]);
        }
        fRESFederzylinderSROarray = fRESFederzylinderSROarray.reverse();
    } else if (driveTypeA === 'AS-C') {
        for (let j = 0; j < khWinkelArray.length; j++) {
            fRESFederzylinderSROValue = (federkraftSROarray[j] / Math.cos(mathFormulaService.degreeToRadians(180 - hebelwinkelGradArray[j]))) * -1;
            fRESFederzylinderSROarray.push(+fRESFederzylinderSROValue.toFixed(0));
        }
    }

    if (driveTypeA === 'AS-S' || driveTypeA === 'ACP') {
        for (let cop = 0; cop < mFEDFederzylinderArray.length; cop++) {
            mFEDFederzylinderSROarray.push(mFEDFederzylinderArray[cop]);
        }
        mFEDFederzylinderSROarray = mFEDFederzylinderSROarray.reverse();
    } else {
        for (let j = 0; j < khWinkelArray.length; j++) {
            // =(V17*E17/1000)*$E$10
            mFEDFederzylinderSROValue = (fRESFederzylinderSROarray[j] * hebellaengeArray[j] / 1000) * base.WIRKUNGSGRADFEDER;
            mFEDFederzylinderSROarray.push(+mFEDFederzylinderSROValue.toFixed(0));
        }
    }

    if (driveTypeA === 'AS-S' || driveTypeA === 'ACP') {
        for (let cop = 0; cop < fQuerFederzylinderArray.length; cop++) {
            fQuerFederzylinderSROarray.push(fQuerFederzylinderArray[cop]);
        }
        fQuerFederzylinderSROarray = fQuerFederzylinderSROarray.reverse();
    } else {
        for (let j = 0; j < khWinkelArray.length; j++) {
            // =(WURZEL(QUADRATESUMME(V17)-QUADRATESUMME(U17)))
            fQuerFederzylinderSROValue = Math.sqrt((fRESFederzylinderSROarray[j] * fRESFederzylinderSROarray[j]) - (federkraftSROarray[j] * federkraftSROarray[j]));;
            fQuerFederzylinderSROarray.push(+fQuerFederzylinderSROValue.toFixed(0));
        }
    }

    if (driveTypeA === 'AS-S' || driveTypeA === 'ACP') {
        for (let cop = 0; cop < mResZylArray.length; cop++) {
            mResZylSROarray.push(mResZylArray[cop]);
        }
        mResZylSROarray = mResZylSROarray.reverse();
    } else {
        for (let j = 0; j < khWinkelArray.length; j++) {
            // =J17-W17
            mResZylSROValue = mZylArray[j] - mFEDFederzylinderSROarray[j]
            mResZylSROarray.push(mResZylSROValue);
        }
    }

    klappeSRO_BTOETOarray = getKlappe().open;
    klappeSRO_BTCETCarray = getKlappe().close;

    return {
        src: {
            federkraftArray: federkraftArray,
            fRESFederzylinderArray: fRESFederzylinderArray,
            mFEDFederzylinderArray: mFEDFederzylinderArray,
            fQuerFederzylinderArray: fQuerFederzylinderArray,
            mResZylArray: mResZylArray,
            klappeBTOETOArray: klappeBTOETOArray,
            klappeBTCETCArray: klappeBTCETCArray,
        },
        sro: {
            federkraftSROarray: federkraftSROarray,
            fRESFederzylinderSROarray: fRESFederzylinderSROarray,
            mFEDFederzylinderSROarray: mFEDFederzylinderSROarray,
            fQuerFederzylinderSROarray: fQuerFederzylinderSROarray,
            mResZylSROarray: mResZylSROarray,
            klappeSRO_BTOETOarray: klappeSRO_BTOETOarray,
            klappeSRO_BTCETCarray: klappeSRO_BTCETCarray
        }
    }
}



const checkChartSRO = (mFEDFederzylinderSROarray: number[], mResZylSROarray: number[], maxNetActuatorTorque: number) => {
    const klappeOpen = getKlappe().open;
    const klappeClose = getKlappe().close;
    const drehwinkelExist = isCustomDrehwinkel();


    let federOK: boolean = false;
    let federAbove: boolean = true;
    let pneumZylinderAbove: boolean = true;
    let isOverMaxAct: boolean = false;

    const wko = getWinkelkraftObject();

    let iBto = winkelToTableIndex(Number(wko?.bto?.bisWinkel ?? 0), 'forward');
    let iBtoRunning = winkelToTableIndex(Number(wko?.btoRunning?.bisWinkel ?? 90), 'forward');
    let iEto = winkelToTableIndex(Number(wko?.eto?.bisWinkel ?? 90), 'forward');

    let iBtc = winkelToTableIndex(Number(wko?.btc?.bisWinkel ?? 90), 'forward');

    let iBtcRunning = winkelToTableIndex(Number(wko?.btcRunning?.bisWinkel ?? 0), 'forward');
    let iEtc = winkelToTableIndex(Number(wko?.etc?.bisWinkel ?? 0), 'forward');

    if (drehwinkelExist) {
        /*
         * Custom-Drehwinkel: iBto/iBtc sind Tabellen-INDIZES (0..100), keine Gradzahl.
         * Mapping forward: 0° → Index 95, 90° → Index 5 (kleinerer Index = größerer Winkel).
         * Beispiel BTO 22° → iBto=73, BTC 79° → iBtc=16.
         * Schleife läuft daher von min(iBtc,iBto) bis max(...), nicht über Gradwerte.
         */
        for (let idx = Math.min(iBtc, iBto); idx <= Math.max(iBtc, iBto); idx++) {
            if (mFEDFederzylinderSROarray[idx] < klappeClose[idx]) {
                federAbove = false;
                break;
            }
            if (mResZylSROarray[idx] < klappeOpen[idx]) {
                pneumZylinderAbove = false;
                break;
            }
        }
    } else {
        for (let i = 0; i <= 90; i++) {
            const idx = winkelToTableIndex(i, 'forward');
            if (mFEDFederzylinderSROarray[idx] < klappeClose[idx]) {
                federAbove = false;
                break;
            }
            if (mResZylSROarray[idx] < klappeOpen[idx]) {
                pneumZylinderAbove = false;
                break;
            }
        }
    }



    // if (drehwinkelExist) {
    //     for (let i = 0; i < angleValues.length; i++) {
    //         if (mFEDFederzylinderSROarray[angleValues[i]] < klappeOpen[angleValues[i]]) {
    //             federAbove = false;
    //         }
    //         if (mResZylSROarray[angleValues[i]] < klappeClose[angleValues[i]]) {
    //             pneumZylinderAbove = false;
    //         }
    //     }
    // } else {
    //     for (let i = 0; i < defaultAngleValues.length; i++) {
    //         if (mFEDFederzylinderSROarray[defaultAngleValues[i]] < klappeOpen[defaultAngleValues[i]]) {
    //             federAbove = false;
    //         }
    //         if (mResZylSROarray[defaultAngleValues[i]] < klappeClose[defaultAngleValues[i]]) {
    //             pneumZylinderAbove = false;
    //         }
    //     }
    // }

    if (federAbove && pneumZylinderAbove) {
        federOK = true;
    }

    if (federOK) {
        if (drehwinkelExist) {
            /*
             * SRO: Öffnen = mFED (BTO/ETO), Schließen = mResZyl (BTC/ETC).
             * Max-Drehmoment an den jeweiligen Endpunkten prüfen (nicht Open-Index auf Close-Array).
             */
            if (mFEDFederzylinderSROarray[iBto] > maxNetActuatorTorque || mFEDFederzylinderSROarray[iEto] > maxNetActuatorTorque || mResZylSROarray[iBtc] > maxNetActuatorTorque || mResZylSROarray[iEtc] > maxNetActuatorTorque) {
                isOverMaxAct = true;

            }
        } else {
            if (mFEDFederzylinderSROarray[winkelToTableIndex(0, 'forward')] > maxNetActuatorTorque || mFEDFederzylinderSROarray[winkelToTableIndex(90, 'forward')] > maxNetActuatorTorque || mResZylSROarray[winkelToTableIndex(0, 'forward')] > maxNetActuatorTorque || mResZylSROarray[winkelToTableIndex(90, 'forward')] > maxNetActuatorTorque) {
                isOverMaxAct = true;

            }
        }
    }


    // for (let i = 0; i < angleValues.length; i++) {
    //     if (mFEDFederzylinderSROarray[angleValues[i]] > maxNetActuatorTorque || mResZylSROarray[angleValues[i]] > maxNetActuatorTorque) {
    //         isOverMaxAct = true;
    //         break;
    //     }
    // }

    return {
        federOK: federOK,
        isOverMaxAct: isOverMaxAct,
        cantedEndmomentLaufmomentOK: (mResZylSROarray[5] >= mResZylSROarray[50]) // TODO: Björn check if this is correct - endmoment größer gleich laufmoment (Bei Kninckwinkel 12 - canted)??
    }
}

const checkChartSRC = (mFEDFederzylinderArray: number[], mResZylArray: number[], maxNetActuatorTorque: number, antrieb?: any, zyl?: any, federPaket?: any) => {
    const klappeOpen = getKlappe().open;
    const klappeClose = getKlappe().close;
    const drehwinkelExist = isCustomDrehwinkel();

    let federOK: boolean = false;
    let federAbove: boolean = true;
    let pneumZylinderAbove: boolean = true;
    let isOverMaxAct: boolean = false;

    const wko = getWinkelkraftObject();

    let iBto = winkelToTableIndex(Number(wko?.bto?.bisWinkel ?? 0), 'forward');
    let iBtoRunning = winkelToTableIndex(Number(wko?.btoRunning?.bisWinkel ?? 90), 'forward');
    let iEto = winkelToTableIndex(Number(wko?.eto?.bisWinkel ?? 90), 'forward');

    let iBtc = winkelToTableIndex(Number(wko?.btc?.bisWinkel ?? 90), 'forward');

    let iBtcRunning = winkelToTableIndex(Number(wko?.btcRunning?.bisWinkel ?? 0), 'forward');
    let iEtc = winkelToTableIndex(Number(wko?.etc?.bisWinkel ?? 0), 'forward');


    // const btoWertDrehmoment = mResZylArray[iBto];
    // const btoRunningWertDrehmoment = mResZylArray[iBtoRunning];
    // const btcWertDrehmoment = mResZylArray[iBtc];

    // const etoWertDrehmoment = mFEDFederzylinderArray[iEto];
    // const btcRunningWertDrehmoment = mFEDFederzylinderArray[iBtcRunning];
    // const etcWertDrehmoment = mFEDFederzylinderArray[iEtc];


    if (drehwinkelExist) {
        /*
         * Custom-Drehwinkel: iBto/iBtc sind Tabellen-INDIZES (0..100), keine Gradzahl.
         * Mapping forward: 0° → Index 95, 90° → Index 5 (kleinerer Index = größerer Winkel).
         * Beispiel BTO 22° → iBto=73, BTC 79° → iBtc=16.
         * Schleife läuft daher von min(iBtc,iBto) bis max(...), nicht über Gradwerte.
         */
        for (let idx = Math.min(iBtc, iBto); idx <= Math.max(iBtc, iBto); idx++) {
            if (mFEDFederzylinderArray[idx] < klappeClose[idx]) {
                federAbove = false;
                break;
            }
            if (mResZylArray[idx] < klappeOpen[idx]) {
                pneumZylinderAbove = false;
                break;
            }
        }
    } else {
        for (let i = 0; i <= 90; i++) {
            const idx = winkelToTableIndex(i, 'forward');
            if (mFEDFederzylinderArray[idx] < klappeClose[idx]) {
                federAbove = false;
                break;
            }
            if (mResZylArray[idx] < klappeOpen[idx]) {
                pneumZylinderAbove = false;
                break;
            }
        }
    }

    if (federAbove && pneumZylinderAbove) {
        federOK = true;
    }

    // for (let i = 0; i < angleValues.length; i++) {
    //     if (mFEDFederzylinderArray[angleValues[i]] > maxNetActuatorTorque || mResZylArray[angleValues[i]] > maxNetActuatorTorque) {
    //         isOverMaxAct = true;
    //         break;
    //     }
    // }

    if (federOK) {
        if (drehwinkelExist) {
            /*
             * SRC: Öffnen = mResZyl (BTO/ETO), Schließen = mFED (BTC/ETC).
             * Max-Drehmoment an den jeweiligen Endpunkten prüfen (nicht Open-Index auf Close-Array).
             */
            if (mFEDFederzylinderArray[iBtc] > maxNetActuatorTorque || mFEDFederzylinderArray[iEtc] > maxNetActuatorTorque || mResZylArray[iBto] > maxNetActuatorTorque || mResZylArray[iEto] > maxNetActuatorTorque) {
                isOverMaxAct = true;

            }
        } else {
            if (mFEDFederzylinderArray[winkelToTableIndex(0, 'forward')] > maxNetActuatorTorque || mFEDFederzylinderArray[winkelToTableIndex(90, 'forward')] > maxNetActuatorTorque || mResZylArray[winkelToTableIndex(0, 'forward')] > maxNetActuatorTorque || mResZylArray[winkelToTableIndex(90, 'forward')] > maxNetActuatorTorque) {
                isOverMaxAct = true;

            }
        }

    }

    //console.log(antrieb, zyl, federPaket, mFEDFederzylinderArray[winkelToTableIndex(90, 'forward')]);






    return {
        federOK: federOK,
        isOverMaxAct: isOverMaxAct,
        cantedEndmomentLaufmomentOK: (mResZylArray[5] >= mResZylArray[50])
    }

}

const checkChartDA = (mZylArray: number[], mZylArrayClose: number[], antriebIndex: any, zylIndex: any, winkelIndexMode: 'forward' | 'reverse', maxNetActuatorTorque: number) => {

    const drehwinkelExist = isCustomDrehwinkel();
    let isOverMaxAct: boolean = false;
    let ismZylOK: boolean = true;

    const klappeOpen = getKlappe().open;
    const klappeClose = getKlappe().close;

    const wko = getWinkelkraftObject();

    /*
     * bisWinkel (°) → Tabellen-Index in mZylArray / klappeOpen / klappeClose.
     * forward: Index = 95 - Winkel  (0° → 95, 22° → 73, 79° → 16, 90° → 5)
     * Wichtig: iBto/iBtc sind Indizes, keine Grad – nicht nochmal winkelToTableIndex darauf anwenden.
     */
    let iBto = winkelToTableIndex(Number(wko?.bto?.bisWinkel ?? 0), winkelIndexMode);
    let iBtoRunning = winkelToTableIndex(Number(wko?.btoRunning?.bisWinkel ?? 90), winkelIndexMode);
    let iEto = winkelToTableIndex(Number(wko?.eto?.bisWinkel ?? 90), winkelIndexMode);

    let iBtc = winkelToTableIndex(Number(wko?.btc?.bisWinkel ?? 90), winkelIndexMode);

    let iBtcRunning = winkelToTableIndex(Number(wko?.btcRunning?.bisWinkel ?? 0), winkelIndexMode);
    let iEtc = winkelToTableIndex(Number(wko?.etc?.bisWinkel ?? 0), winkelIndexMode);


    // ASG-110S-200-DA



    if (antriebIndex === 1 && zylIndex === 9) {
        //     console.log('wko', wko);
        //     console.log('mZylArray', mZylArray);
        // console.log('iBto', iBto, mZylArray[iBto]);
        // console.log('iBtoRunning', iBtoRunning, mZylArray[iBtoRunning]);
        // console.log('iEto', iEto, mZylArray[iEto]);


        // console.log('--------------------------------');
        // console.log('mZylArrayClose', mZylArrayClose);
        // console.log('iBtc', iBtc, mZylArrayClose[iBtc]);
        // console.log('iBtcRunning', iBtcRunning, mZylArrayClose[iBtcRunning]);
        // console.log('iEtc', iEtc, mZylArrayClose[iEtc]);


    }


    const btoWertDrehmoment = mZylArray[iBto];
    const btoRunningWertDrehmoment = mZylArray[iBtoRunning];
    const btcWertDrehmoment = mZylArray[iBtc];

    const etoWertDrehmoment = mZylArrayClose[iEto];
    const btcRunningWertDrehmoment = mZylArrayClose[iBtcRunning];
    const etcWertDrehmoment = mZylArrayClose[iEtc];









    const btoWertKlappe = klappeOpen[iBto];
    const btoRunningWertKlappe = klappeOpen[iBtoRunning];
    const btcWertKlappe = klappeClose[iBtc];
    const btcRunningWertKlappe = klappeClose[iBtcRunning];

    if (btoWertDrehmoment > btoWertKlappe && btoRunningWertDrehmoment > btoRunningWertKlappe && btcWertDrehmoment > btcWertKlappe && btcRunningWertDrehmoment > btcRunningWertKlappe) {
        ismZylOK = true;
    } else {
        ismZylOK = false;
    }

    if (!drehwinkelExist) {
        /* Standard-Drehwinkel: physikalische Winkel 0°..90° in Tabellen-Index umrechnen */
        for (let angle = 0; angle <= 90; angle++) {
            const idx = winkelToTableIndex(angle, winkelIndexMode);
            if (
                mZylArray[idx] <= klappeOpen[idx] ||
                mZylArrayClose[idx] <= klappeClose[idx]
            ) {
                ismZylOK = false;
                break;
            }
        }
    } else {
        /*
         * Custom-Drehwinkel: über Tabellen-Indizes von BTC bis BTO iterieren.
         * iBtc liegt meist UNTER iBto (z.B. 79°→16, 22°→73), deshalb min/max statt iBto..iBtc.
         */
        for (let idx = Math.min(iBtc, iBto); idx <= Math.max(iBtc, iBto); idx++) {
            if (
                mZylArray[idx] <= klappeOpen[idx] ||
                mZylArrayClose[idx] <= klappeClose[idx]
            ) {
                ismZylOK = false;
                break;
            }
        }
    }

    

    if (ismZylOK) {

        if (drehwinkelExist) {
            /*
             * DA: Öffnen = mZylArray (BTO/ETO), Schließen = mZylArrayClose (BTC/ETC).
             * ETC bei 0° = Index iEtc (z.B. 95), nicht iEto (90° = Index 5).
             */
            if (mZylArray[iBto] > maxNetActuatorTorque || mZylArray[iEto] > maxNetActuatorTorque || mZylArrayClose[iBtc] > maxNetActuatorTorque || mZylArrayClose[iEtc] > maxNetActuatorTorque) {
                isOverMaxAct = true;

            } 
        } else {
            if (mZylArray[winkelToTableIndex(0, winkelIndexMode)] > maxNetActuatorTorque || mZylArray[winkelToTableIndex(90, winkelIndexMode)] > maxNetActuatorTorque || mZylArrayClose[winkelToTableIndex(0, winkelIndexMode)] > maxNetActuatorTorque || mZylArrayClose[winkelToTableIndex(90, winkelIndexMode)] > maxNetActuatorTorque) {
                isOverMaxAct = true;

            }
        }

    }

    return {
        isOverMaxAct: isOverMaxAct,
        ismZylOK: ismZylOK,
        cantedEndmomentLaufmomentOK: ((mZylArray[5] >= mZylArray[50]) || (mZylArrayClose[5] >= mZylArrayClose[50])) // TODO: Björn check if this is correct - endmoment größer gleich laufmoment (Bei Kninckwinkel 12 - canted)??
    }
}

const ml = (driveType: string, driveTypeA: string, antrieb: string, zylKey: number, controlType: string, federKEY: string, asAuto?: number) => {
    let driveTypeASHORT = (asAuto === 0) ? 'S' : 'C'

    if (driveType === 'DA') {
        return 'AS' + controlType + '-' + antrieb + driveTypeASHORT + '-' + zylKey + '-' + driveType;
    } else {
        return 'AS' + controlType + '-' + antrieb + driveTypeASHORT + '-' + zylKey + '-' + driveType + '-' + federKEY;
    }
}

const actuatorService = {
    setMaxNettoAntrieb,
    setSecurityFactors,
    getSecurityFactors,
    setTorques,
    setWinkelkraft,
    getZylinderraum,
    flaecheZylinderrohrraum,
    setKlappe,
    getKlappe,
    getZylinderkraft,
    getTable,
    getFederTable,
    checkChartDA,
    checkChartSRO,
    checkChartSRC,
    isCustomDrehwinkel,
    ml
};

export default actuatorService;
